/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Edit reference STL body</h4>

<p>Move, flip, or scale imported reference body.</p>
<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>X,Y,Z</b>: Translate along the X, Y or Z direction</li>
    <li class='shortcuts__item'><b>Shift-X,Y,Z</b>: Translate along -X, -Y or -Z</li>
    <li class='shortcuts__item'><b>Up-arrow, Down-arrow</b>: Scale up or down proportionately</li>
    <li class='shortcuts__item'><b>1, 2, 3, shift-1,-2-3</b>: Scale along X, Y or Z</li>
    <li class='shortcuts__item'><b>DELETE</b>: Deletes the reference body</li>
</ul>`;

export default function EditSTLTooltip() {
    return h('div', { innerHTML: body });
}
